import { createFeature, createReducer, on } from '@ngrx/store'
import { UserState } from './user.state'
import { userActions } from './user.actions'

const createInitialState = (): UserState => ({ userName: null })

export const userFeature = createFeature({
    name: 'user',
    reducer: createReducer<UserState>(
        createInitialState(),
        on(
            userActions.logoutFinished,
            (state): UserState => ({
                ...state,
                userName: null,
            })
        ),
        on(
            userActions.usernameLoaded,
            (state, { userName }): UserState => ({
                ...state,
                userName,
            })
        )
    ),
})

export const { reducer } = userFeature
